import { ApprovedIcon } from '@/assets/icons/info-icons/approved';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface SuccessProps {
  onClose: () => void;
  isOpen: boolean;
}

const Success = ({ onClose, isOpen }: SuccessProps) => {
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      showCancelButton={false}
      confirmButton={{
        name: 'OK',
        onClick: onClose
      }}
    >
      <ModalBody>
        <ApprovedIcon width={75} height={75} fill={themeVar('context.success')} />
        <ModalTitle>Update Successful</ModalTitle>
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default Success;

const ModalTitle = styled.div`
  color: ${themeVar('font.strong')};
  text-align: center;
  font-size: 33px;
  font-weight: 400;
  line-height: 46.2px;
`;

const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  margin: 30px 0 30px 0;
`;
